function MountainPlanetIII() {
    return (
        <div className="planet-iii-mountain-container">
            <div className="planet-iii-mountain"></div>
        </div>
    )
}

export { MountainPlanetIII }